// config.js

const config = {
  apiUrl: "https://backend.mohmsa.com/api", // Replace with your actual API base URL
};

export default config;
